export const CLT_GATEWAY_API_NAME = 'clt-gateway';
